if (!customElements.get('contact-form-conditional')) {
  class ContactFormConditional extends HTMLElement {
    connectedCallback() {
      this.fields = this.querySelectorAll('[data-contact-conditional]');
      if (!this.fields.length) return;

      this.handleChange = this.handleChange.bind(this);
      this.bindings = [];
      this.fields.forEach(field => this.bindField(field));
    }

    disconnectedCallback() {
      if (!this.bindings) return;
      this.bindings.forEach(({ watcher }) => {
        watcher.removeEventListener('change', this.handleChange);
      });
    }

    bindField(field) {
      let config;
      try { config = JSON.parse(field.dataset.contactConditional); }
      catch (e) { return; }
      const watcher = document.getElementById(config.watch);
      if (!watcher) return;

      this.bindings.push({ field, watcher, showWhen: config.showWhen });
      watcher.addEventListener('change', this.handleChange);
      this.applyVisibility(field, watcher, config.showWhen);
    }

    handleChange() {
      this.bindings.forEach(({ field, watcher, showWhen }) => {
        this.applyVisibility(field, watcher, showWhen);
      });
    }

    applyVisibility(field, watcher, showWhen) {
      const isEnabled = watcher.value === showWhen;
      const control = field.querySelector('select, input, textarea');
      if (!control) return;

      if (isEnabled) {
        control.removeAttribute('disabled');
        control.setAttribute('required', '');
        control.setAttribute('aria-required', 'true');
      } else {
        control.setAttribute('disabled', '');
        control.removeAttribute('required');
        control.setAttribute('aria-required', 'false');
        if (control.tagName === 'SELECT') {
          control.selectedIndex = 0;
        } else {
          control.value = '';
        }
      }

      if (!isEnabled) {
        field.setAttribute('data-conditional-hidden', '');
      } else {
        field.removeAttribute('data-conditional-hidden');
      }
    }
  }
  customElements.define('contact-form-conditional', ContactFormConditional);
}
